export default __webpack_public_path__ + "static/media/bannersweb_checoleyenda_rojo_.70190408.jpg";